<template>
  <div class="bg-light">
    <DefaultHeader/>
    <b-container class="bg-light px-5">
      <b-row>
        <b-col>
          <h3 class="mt-3">Solicitação de 2ª Via</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="pl-2 mt-4">
            Para solicitar a segunda via do seu cartão, basta preencher os dados abaixo.
          </p>
          <p class="pl-2 mt-4">
            O formulário deve ser preenchido com os dados do <span style="color: #002e8a">titular do cartão</span>.
          </p>
        </b-col>
      </b-row>

      <RequestForm @submitTicketAction="registerTicketRequest($event)" formType="secondTicket"/>

      <CommonModals @submit="sellForm()" @secondSubmit="resetForm()"/>

      <CancelFeedbackModals :protocol="protocol" type="secondTicket"/>

      <PrivacyModal/>

    </b-container>
  </div>
</template>

<script>
import CommonModals from '../components/modals.vue'
import CancelFeedbackModals from '../components/cancelFeedbackModal.vue'
import RequestForm from '../components/requestForm.vue'
import PrivacyModal from '../components/privacyModal.vue'
import DefaultHeader from '../components/defaultHeader.vue'

export default {
	components: {
		CommonModals,
    CancelFeedbackModals,
    RequestForm,
    PrivacyModal,
    DefaultHeader
	},
  data() {
    return {
      protocol: {
        cancelling: '',
        secondTicket: ''
      },
    }
  },
  mounted() {
    this.$bvModal.show('privacy-modal')
  },
  methods: {
    async registerTicketRequest(data) {
      await this.callApi('post', 'registerNewRequest', this.newPayload(data)).then(response => {
        if(response.status == 201) {
          this.protocol.secondTicket = response.data.id
          this.$emit('resetForm')
          this.$bvModal.show('second-ticket-modal')
          return
        }
        this.$bvModal.show('error-modal')
      }).catch((err) => {
        console.log(err)
      });
    },
    newPayload(data) {
      return {
        cpf: data.clientData.cpf,
        rg: data.clientData.rg,
        name: data.clientData.name,
        email: data.contactData.email,
        residentialNumber: data.contactData.phone,
        cellphoneNumber: data.contactData.cellphone,
        whatsApp: data.contactData.whats,
        cardCategory: data.requestData.cardCategory
      }
    }
  }
}
</script>

<style>
.container {
  height: calc(100vh - 56px);
  /* overflow: hidden; */
}
</style>